import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Form } from 'react-final-form';
import { Button, H1, H2, H3, InputNumber, InputSelectNative, OPTIONS_HOUSING, OPTIONS_INCOME_SOURCE, OPTIONS_PAY_FREQUENCY, parseAmount, validateRequiredField, } from 'shared';
function AdditionalInfoEDS({ handleSubmit }) {
    // Form Validation
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.paymentFrequency) {
                errors.paymentFrequency = 'Please select a payment frequency';
            }
            if (!values.annualIncome) {
                errors.annualIncome = 'Please enter annual income';
            }
            if (!values.primaryIncomeSource) {
                errors.primaryIncomeSource = 'Please select a primary income source';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    // Form Submit
    const formSubmit = async (values) => {
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                // Form is valid
                if (handleSubmit) {
                    handleSubmit({
                        paymentFrequency: values.paymentFrequency,
                        annualIncome: parseAmount(values.annualIncome),
                        primaryIncomeSource: values.primaryIncomeSource,
                    });
                }
                return undefined;
            }
            else {
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    return (_jsx("div", { className: "max-width-800 mar-auto", children: _jsx(Form, { onSubmit: formSubmit, render: ({ handleSubmit, submitting, hasValidationErrors }) => (_jsxs("form", { onSubmit: handleSubmit, className: "additional-info-form", children: [_jsx(H1, { children: "Additional Info" }), _jsx(H2, { variant: "headline-small", className: "mar-t-32", children: "We need to capture a few additional details to continue with your application." }), _jsx("div", { className: "section-title pad-8 mar-t-32 mar-b-0", children: _jsx(H3, { variant: "headline-small", className: "mar-b-0", children: "Income Details" }) }), _jsx("br", {}), _jsx("br", {}), _jsxs("div", { className: "flex-col", children: [_jsx(InputSelectNative, { name: "primaryIncomeSource", label: 'Primary Income Source', placeholder: "Select primary income source", options: OPTIONS_INCOME_SOURCE, required: true }), _jsx("br", {}), _jsx("br", {}), _jsx(Field, { name: "annualIncome", component: InputNumber, options: OPTIONS_HOUSING, preicon: "$", allowLeadingZeros: false, thousandsGroupStyle: "thousand", thousandSeparator: ",", decimalScale: 2, placeholder: "Annual income", label: "Annual Income", fieldclass: "housing-payment-input", validate: validateRequiredField }), _jsx("br", {}), _jsx("br", {}), _jsx(InputSelectNative, { name: "paymentFrequency", label: 'Payment Frequency', options: OPTIONS_PAY_FREQUENCY, placeholder: "Select payment frequency", required: true })] }), _jsx(Button, { type: "submit", className: "button-warn mar-t-64", submitting: submitting, disabled: submitting || hasValidationErrors, children: "CONTINUE" })] })) }) }));
}
export default AdditionalInfoEDS;
